/**
 * @generated SignedSource<<c5dbbe3621811d133d8b7c7db2fd69a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteHolidayCalendarInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteHolidayCalendarMutation$variables = {
  input: DeleteHolidayCalendarInput;
};
export type deleteHolidayCalendarMutation$data = {
  readonly deleteHolidayCalendar: {
    readonly deletedHolidayCalendarId: string | null;
  } | null;
};
export type deleteHolidayCalendarMutation = {
  variables: deleteHolidayCalendarMutation$variables;
  response: deleteHolidayCalendarMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteHolidayCalendarPayload",
    "kind": "LinkedField",
    "name": "deleteHolidayCalendar",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedHolidayCalendarId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteHolidayCalendarMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteHolidayCalendarMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "606277185f8df24ca3d191e57518ed41",
    "id": null,
    "metadata": {},
    "name": "deleteHolidayCalendarMutation",
    "operationKind": "mutation",
    "text": "mutation deleteHolidayCalendarMutation(\n  $input: DeleteHolidayCalendarInput!\n) {\n  deleteHolidayCalendar(input: $input) {\n    deletedHolidayCalendarId\n  }\n}\n"
  }
};
})();

(node as any).hash = "93df777568488b5a933ad12cc6daa526";

export default node;
